module.exports = __webpack_public_path__ + "static/pexels-julia-m-cameron-4144101-4-3103d4adb00aaf52bc5e3e675f98040e.jpg";